import {capitalize} from '@mui/material';
import ImageUploadContainer from 'components/ImageUploadContainer';
import {presetDimensions} from 'components/imaging/ResizedDasWebImage';
import AnalyticsGateway from 'lib/AnalyticsGateway';
import PropertyDetailImages from 'lib/PropertyDetailImages';
import PropTypes from 'prop-types';
import {Component} from 'react';
import {connect} from 'react-redux';
import {Container, Divider} from 'semantic-ui-react';
import './PropertyImages.scss';
import {PropertyImageGalleryContainer} from 'components/PropertyImageGallery';

/**
 * Component for viewing a property's photo gallery and the image upload field. This should be moved to Material, but
 * there is a redesign closer to Crux's in another story.
 */
export class PropertyImages extends Component {
  static propTypes = {
    comparableType: PropTypes.string,
    deletableImages: PropTypes.arrayOf(PropTypes.string),
    dispatch: PropTypes.func,
    objectContext: PropTypes.string,
    onDelete: PropTypes.func.isRequired,
    onUpload: PropTypes.func.isRequired,
    pageContext: PropTypes.string,
    propertyDetail: PropTypes.shape({
      propertyId: PropTypes.number,
      propertyPhotoList: PropTypes.arrayOf(PropTypes.string),
      reportType: PropTypes.shape({
        value: PropTypes.string,
      }),
    }),
    reportType: PropTypes.shape({ value: PropTypes.string.isRequired }).isRequired,
    uploadProgress: PropTypes.number,
  };

  state = {
    currentIndex: 0,
    errorMsg: '',
    overrideDropStyle: {},
  };

  onIndexChange = (context) => {
    return (currentIndex) => {
      const {
        propertyDetail: { propertyId },
        reportType: { value: reportTypeValue },
        objectContext,
        pageContext,
      } = this.props;
      this.setState({ currentIndex });
      if (context) {
        AnalyticsGateway.sendEvent({
          eventName: `Navigate ${context} Carousel`,
          properties: [
            { label: 'Page', value: pageContext },
            { label: 'Object Context', value: objectContext },
            { label: 'Report Type', value: AnalyticsGateway.reportDescription(reportTypeValue) },
            { label: 'Property ID', value: propertyId },
          ],
        });
      }
    };
  };

  onImageReject = (errors) => {
    let errorReason = errors[0];
    this.setState({
      ...this.state,
      errorMsg: `Image not uploaded. ${errorReason}`,
      overrideDropStyle: {
        borderColor: '#f65c5d',
        backgroundColor: '#fef5f4',
      },
    });
  };

  onImageUpload = (files, eventType) => {
    this.setState({
      ...this.state,
      errorMsg: '',
      overrideDropStyle: {},
    });
    const { onUpload } = this.props;
    this.onIndexChange()(0);
    onUpload(files, eventType);
  };

  onImageDelete = (index) => {
    const { onDelete } = this.props;
    this.onIndexChange()(0);
    onDelete(index);
  };

  render() {
    const { comparableType, deletableImages, propertyDetail, objectContext, pageContext } = this.props;
    const { currentIndex, errorMsg, overrideDropStyle } = this.state;

    const images = PropertyDetailImages.list(propertyDetail);
    return (
      <div className="property-images">
        <PropertyImageGalleryContainer comparableType={comparableType}
                                       currentIndex={currentIndex}
                                       deletableImages={deletableImages}
                                       images={images}
                                       inlineGalleryProps={{
                                         imageProps: {
                                           size: 'large',
                                         },
                                         onIndexChange: this.onIndexChange('Inline')
                                       }}
                                       modalProps={{
                                         onIndexChange: this.onIndexChange('Gallery')
                                       }}
                                       objectContext={objectContext}
                                       pageContext={pageContext}
                                       propertyId={propertyDetail.propertyId}
                                       resizeProps={{isResize: true, resizeDimensions: presetDimensions.PROPERTY_FEATURED}}
                                       onDelete={this.onImageDelete}
                                       onIndexChange={this.onIndexChange('Inline')}/>
        <Container className="dropzone" style={{ cursor: 'pointer' }}>
          <Divider hidden />
          <ImageUploadContainer
            className="property-images"
            comparableType={comparableType}
            onUpload={this.onImageUpload}
            onReject={this.onImageReject}
            propertyId={propertyDetail.propertyId}
            objectContext={objectContext}
            pageContext={pageContext}
            style={overrideDropStyle}
          />
        </Container>
        <Container className="dropzone-error-container" fluid text textAlign="center">
          <p className="error-label">{errorMsg}</p>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { propertyDetail: { propertyId } = {}, comparableType = '' } = ownProps;
  const isTargetProperty = !propertyId || state.propertyDetail?.propertyId === propertyId;
  const objectContext = isTargetProperty
    ? 'Target Property'
    : `Comparable ${capitalize(comparableType)}`;
  const pageContext = isTargetProperty ? 'Target Property' : 'Customise Report';
  return {
    ...state,
    ...ownProps,
    pageContext,
    objectContext,
  };
};

export default connect(mapStateToProps)(PropertyImages);
